// Unit of Measure (UOM) codes as per GST UQC list
export const UOM_LIST = [
  { code: 'BAG', unit: 'BAGS' },
  { code: 'BAL', unit: 'BALE' },
  { code: 'BDL', unit: 'BUNDLES' },
  { code: 'BKL', unit: 'BUCKLES' },
  { code: 'BOU', unit: 'BILLION OF UNITS' },
  { code: 'BOX', unit: 'BOX' },
  { code: 'BTL', unit: 'BOTTLES' },
  { code: 'BUN', unit: 'BUNCHES' },
  { code: 'CAN', unit: 'CANS' },
  { code: 'CBM', unit: 'CUBIC METERS' },
  { code: 'CCM', unit: 'CUBIC CENTIMETERS' },
  { code: 'CMS', unit: 'CENTIMETERS' },
  { code: 'CTN', unit: 'CARTONS' },
  { code: 'DOZ', unit: 'DOZENS' },
  { code: 'DRM', unit: 'DRUMS' },
  { code: 'GGK', unit: 'GREAT GROSS' },
  { code: 'GMS', unit: 'GRAMMES' },
  { code: 'GRS', unit: 'GROSS' },
  { code: 'GYD', unit: 'GROSS YARDS' },
  { code: 'KGS', unit: 'KILOGRAMS' },
  { code: 'KLR', unit: 'KILOLITRE' },
  { code: 'KME', unit: 'KILOMETRE' },
  { code: 'LTR', unit: 'LITRES' },
  { code: 'MLT', unit: 'MILILITRE' },
  { code: 'MTR', unit: 'METERS' },
  { code: 'MTS', unit: 'METRIC TON' },
  { code: 'NOS', unit: 'NUMBERS' },
  { code: 'PAC', unit: 'PACKS' },
  { code: 'PCS', unit: 'PIECES' },
  { code: 'PRS', unit: 'PAIRS' },
  { code: 'QTL', unit: 'QUINTAL' },
  { code: 'ROL', unit: 'ROLLS' },
  { code: 'SET', unit: 'SETS' },
  { code: 'SQF', unit: 'SQUARE FEET' },
  { code: 'SQM', unit: 'SQUARE METERS' },
  { code: 'SQY', unit: 'SQUARE YARDS' },
  { code: 'TBS', unit: 'TABLETS' },
  { code: 'TGM', unit: 'TEN GROSS' },
  { code: 'THD', unit: 'THOUSANDS' },
  { code: 'TON', unit: 'TONNES' },
  { code: 'TUB', unit: 'TUBES' },
  { code: 'UGS', unit: 'US GALLONS' },
  { code: 'UNT', unit: 'UNITS' },
  { code: 'YDS', unit: 'YARDS' },
  { code: 'OTH', unit: 'OTHERS' }
];

// Options for antd Select components
export const UOM_OPTIONS = UOM_LIST.map(({ code, unit }) => ({
  value: code,
  label: `${code} - ${unit}`
}));
